<template>
  <div class="animated fadeIn" id="incPaymentsRoot">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Contractual Invoices/Payments
          </div>
          <div class="card-block">
            <div>
              <table class="table table-bordered table-striped table-condensed">
                <thead>
                <tr class="table-data" >
                  <th class="text-center table-head-th">Contractual invoice date</th>
                  <th class="text-center table-head-th">Forecasted invoice date</th>
                  <th class="text-center table-head-th">Forecasted payment date</th>
                  <th class="text-center table-head-th">Project</th>
                  <th class="text-center table-head-th">Revenue</th>
                  <th class="text-center table-head-th">Prepayment</th>
                  <th class="text-center table-head-th">To Be Paid</th>
                  <th class="text-center table-head-th">Description</th>
                  <th class="text-center table-head-th">Type</th>
                  <th class="text-center table-head-th">Incoming</th>
                  <th class="text-center table-head-th">Actions</th>
                </tr>
                </thead>
                <tfoot>
                <tr class="table-data">

                  <td>
                    <datepicker input-class="contractual-payments-table-date-picker" placeholder="yyyy-mm-dd" v-model="newIncomingPaymentContractualInvoiceDate" format="yyyy-MM-dd"></datepicker>
                    <!--<input type="date" class="form-control w-100" v-model="newIncomingPaymentContractualInvoiceDate">-->
                  </td>
                  <td>
                    <datepicker input-class="contractual-payments-table-date-picker" placeholder="yyyy-mm-dd" v-model="newIncomingPaymentForecastedInvoiceDate" format="yyyy-MM-dd"></datepicker>
                    <!--<input type="date" class="form-control w-100" v-model="newIncomingPaymentForecastedInvoiceDate">-->
                  </td>
                  <td>
                    <datepicker input-class="contractual-payments-table-date-picker" placeholder="yyyy-mm-dd" v-model="newIncomingPaymentForecastedPaymentDate" format="yyyy-MM-dd"></datepicker>
                    <!--<input type="date" class="form-control w-100" v-model="newIncomingPaymentForecastedPaymentDate">-->
                  </td>
                  <td>
                    <select class="form-control w-100" v-model="newIncomingPaymentProject" :disabled="projectId">
                      <option value="" disabled>Project</option>
                      <option v-for="project in projects" :value="project.id">{{project.name}}</option>
                    </select>
                  </td>
                  <td>
                    <input type="number" placeholder="Revenue" class="form-control" min="0" step="0.01" v-model="newIncomingPaymentAmount">
                  </td>
                  <td>
                    <input type="number" placeholder="Prepayment" class="form-control" min="0" step="0.01" v-model="newIncomingPaymentPrepayment">
                  </td>
                  <td>
                    <div>
                      {{newIncomingPaymentToBePaid}}
                    </div>
                  </td>
                  <td><textarea type="text" placeholder="Description" class="textarea-input w-100" v-model="newIncomingPaymentDescription"></textarea></td>
                  <td>
                    <select class="form-control w-100" v-model="newIncomingPaymentType">
                      <option value="planned" selected="selected">Planned</option>
                      <option value="invoiced">Invoiced</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                  <td>
                    <div style="text-align: center; padding: 4px;">
                      <switches
                          v-model="newIncomingPaymentIncoming"
                          color="blue"
                      />
                    </div>
                  </td>
                  <td><button type="button" class="btn btn-primary w-100 btn-sm" @click="saveNewIncomingPayment">Save</button></td>
                </tr>
                </tfoot>
              </table>
            </div>
            <br>
            <hr>
            <br>
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-form-label">Type</label>
                <div class="col-md-2">
                  <select class="form-control form-control-sm" v-model="incomingPaymentFilter.filterType">
                    <option value="" selected="selected">All types</option>
                    <option value="planned">Planned</option>
                    <option value="invoiced">Invoiced</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <button @click="incomingPaymentFilter.filterDateFrom = incomingPaymentFilter.filterDateTo = incomingPaymentFilter.filterType = ''" class="btn btn-sm btn-secondary">Clear filters</button>
                </div>
                <div class="col-md-2" style="padding-top: 5px;">
                    <div v-if="showIncoming" style="display: inline-block">Incoming</div>
                    <div v-else style="display: inline-block">Outgoing</div>
                    <div style="display: inline-block">
                      <switches
                      v-model="showIncoming"
                      color="blue"
                      />
                    </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-form-label pt-0">Forecasted invoice date from</label>
                <div class="col-md-2">
                  <datepicker input-class="contractual-payments-date-picker" :disabled-dates="{from: new Date(incomingPaymentFilter.filterDateTo)}" v-model="incomingPaymentFilter.filterDateFrom" format="yyyy-MM-dd"></datepicker>
                  <!--<input v-model="incomingPaymentFilter.filterDateFrom" class="form-control" type="date"/>-->
                </div>
                <label class="col-form-label pt-0">to</label>
                <div class="col-md-2">
                  <datepicker input-class="contractual-payments-date-picker" :disabled="!incomingPaymentFilter.filterDateFrom" :disabled-dates="{to: new Date(incomingPaymentFilter.filterDateFrom)}" v-model="incomingPaymentFilter.filterDateTo" format="yyyy-MM-dd"></datepicker>
                  <!--<input v-model="incomingPaymentFilter.filterDateTo" class="form-control" type="date"/>-->
                </div>
              </div>
            </div>
            <div class="table-view"  :style="{height: invoicePaymentTableHeight}">
              <table ref="invoicePaymentTable" class="table table-bordered table-striped table-condensed">
                <thead>
                  <tr class="table-data" >
                  <th class="text-center table-head-th">#</th>
                  <th class="text-center table-head-th">Contractual<br />invoice<br />date</th>
                  <th class="text-center table-head-th">Forecasted<br />invoice<br />date</th>
                  <th class="text-center table-head-th">Forecasted<br />payment<br />date</th>
                  <th class="text-center table-head-th">Project</th>
                  <th class="text-right table-head-th currency-header">Revenue</th>
                  <th class="text-right table-head-th currency-header">Prepayment</th>
                  <th class="text-right table-head-th currency-header">To Be Paid</th>
                  <th class="text-center table-head-th">Description</th>
                  <th class="text-center table-head-th">Type</th>
                  <th class="text-center table-head-th">Incoming</th>
                  <th class="text-center table-head-th">Actions</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="incomingPayment in incomingPayments" v-bind:key="incomingPayment.id" @click="" v-if="showIncomingPayment(incomingPayment)" class="table-data">
                    <td class="text-center">{{incomingPayment.id}}</td>
                    <td class="text-center">{{incomingPayment.contractual_invoice_date}}</td>
                    <td class="text-center" @click="incomingPaymentPicketOpen">
                      <datepicker
                              input-class="edit-contractual-payments-date-picker"
                              placeholder="yyyy-mm-dd"
                              v-model="incomingPayment.forecasted_invoice_date"
                              format="yyyy-MM-dd"
                              @selected="(date) => {updateIncomingPaymentForecasetedInvoiceDate(date, incomingPayment)}"
                              @closed="incomingPaymentPickerClose"
                      ></datepicker>
                    </td>
                    <td class="text-center">{{incomingPayment.expected_on}}</td>
                    <td class="text-left"><span @click="$router.push({ name: 'ProjectTabInvoicesPayments', params: { id: incomingPayment.project_id }});" class="action">{{projects[incomingPayment.project_id].name}}</span></td>
                    <!-- <td class="currency">{{parseFloat(incomingPayment.amount).toFixed(2)}}</td> -->
                    <td class="currency text-nowrap text-monospace">{{incomingPayment.amount | numFormat('0,0.00')}}</td>
                    <td class="currency text-nowrap text-monospace">{{incomingPayment.prepayment | numFormat('0,0.00')}}</td>
                    <td class="currency text-nowrap text-monospace">{{incomingPayment.toBePaid | numFormat('0,0.00')}}</td>
                    <td class="description text-left">{{incomingPayment.description}}</td>
                    <td class="text-center">{{incomingPayment.type}}</td>
                    <td class="text-center">{{incomingPayment.incoming ? 'true' : 'false'}}</td>
                    <td>
                      <i class="fa fa-edit fa-lg action" @click="editIncomingPayment(incomingPayment)"></i>
                      <i class="fa fa-trash fa-lg action" v-if="incomingPayment.type != 'invoiced'" @click="deleteIncomingPayment(incomingPayment.id)"></i>
                      <i class="fa fa-file fa-lg action" @click="openContractModal(incomingPayment)" v-b-modal.create-document></i>
                    </td>
                  </tr>
                  <tr class="table-data total-sum-row">
                    <td colspan="5">Total</td>
                    <td class="currency text-nowrap text-right text-monospace">{{parseFloat(incomingPaymentsTableSum).toFixed(2) | numFormat('0,0.00')}}</td>
                    <td class="currency text-nowrap text-right text-monospace">{{parseFloat(prepaymentTableSum).toFixed(2) | numFormat('0,0.00')}}</td>
                    <td class="currency text-nowrap text-right text-monospace">{{parseFloat(toBePaidTableSum).toFixed(2) | numFormat('0,0.00')}}</td>
                    <td colspan="4"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <modal title="Edit Incoming Payment" class="modal-info" :value="isEditingPayment" effect="fade/zoom">
          <div slot="modal-header" class="modal-header">
            <h4 class="modal-title">Edit Incoming Payment</h4>
          </div>
          <div slot="modal-body" class="modal-body">
            <form action="" method="post" enctype="multipart/form-data" class="form-horizontal ">
              <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input">Contractual invoice date</label>
                <div class="col-md-9">
                  <datepicker input-class="edit-contractual-payments-date-picker" placeholder="yyyy-mm-dd" v-model="selectedIncomingPayment.contractual_invoice_date" format="yyyy-MM-dd"></datepicker>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input">Forecasted invoice date</label>
                <div class="col-md-9">
                  <datepicker input-class="edit-contractual-payments-date-picker" placeholder="yyyy-mm-dd" v-model="selectedIncomingPayment.forecasted_invoice_date" format="yyyy-MM-dd"></datepicker>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input">Forecasted payment date</label>
                <div class="col-md-9">
                  <datepicker input-class="edit-contractual-payments-date-picker" placeholder="yyyy-mm-dd" v-model="selectedIncomingPayment.expected_on" format="yyyy-MM-dd"></datepicker>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label" for="textarea-input">Project</label>
                <div class="col-md-9">
                  <select class="form-control w-100" v-model="selectedIncomingPayment.project_id">
                    <option v-for="project in projects" :value="project.id">{{project.name}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label">Revenue</label>
                <div class="col-md-9">
                  <input type="number" placeholder="Revenue" class="form-control" min="0" step="0.01" v-model="selectedIncomingPayment.amount">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label">Prepayment</label>
                <div class="col-md-9">
                  <input type="number" placeholder="Prepayment" class="form-control" min="0" step="0.01" v-model="selectedIncomingPayment.prepayment">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label">To Be Paid</label>
                <div class="col-md-9">
                  <input type="number" disabled placeholder="To Be Paid" class="form-control" :value="selectedIncomingPayment.toBePaid">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label">Description</label>
                <div class="col-md-9">
                  <textarea type="text" placeholder="Description" class="textarea-input w-100" v-model="selectedIncomingPayment.description"></textarea>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-md-3 form-control-label">Type</label>
                <div class="col-md-9">
                  <select class="form-control w-100" v-model="selectedIncomingPayment.type">
                      <option value="planned">Planned</option>
                      <option value="invoiced">Invoiced</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                </div>
              </div>
            </form>
          </div>
          <div slot="modal-footer" class="modal-footer">
            <button type="button" class="btn btn-primary" @click="updateIncomingPayment()">Save changes</button>
            <button type="button" class="btn btn-secondary" @click="isEditingPayment = false">Close</button>
          </div>
        </modal>

        <b-modal id="create-document" title="Create Document">
          <div class="form-group row">
            <label class="col-md-3 form-control-label" for="text-input">Document Template</label>
            <div class="col-md-9">
              <select class="form-control" v-model="selected_template">
                <option selected disabled :value="''">Select template</option>
                <option v-for="template in templates_dropdown" :value="template.id">{{template.contract_name}}</option>
              </select>
            </div>
          </div>
          <template v-slot:modal-footer="{ ok, cancel, hide }">
            <b-button variant="primary" @click="isCreatingContract = false; createNewContract()">Create document</b-button>
            <b-button variant="secondary" @click="hide()">Close</b-button>
          </template>
        </b-modal>
      </div><!--/.col-->
    </div><!--/.row-->
  </div>
</template>
<style lang="scss" scoped>
  .w-100{
    width: 100%;
  }
  .description{
    word-break: break-all;
    padding-inline: 5px;
    padding-left: 0.5rem;
    font-size: 11px;
  }
  .currency::after{
    content: "€";
  }
  .currency, .currency-header {
    padding: 0 0.5rem;
  }
  .action {
    margin-left: 5px;

    &:hover {
      cursor: pointer;
      color: #ee0044;
    }
  }
  .badge-warning{
    &:hover {
      cursor: pointer;
      background-color: #ee0044;
    }
  }

  table {
    font-size: 12px;
  }

  tr.table-data td:not(:first-child):not(:last-child),
  tr.table-data th:not(:first-child):not(:last-child) {
    text-align: right;
  }
  th, td, td > select {
    padding: 0.15rem;
    vertical-align: middle;
  }
  tfoot tr * {
    height: 25px !important;
    margin-bottom: 0;
    margin-top: 0;
    vertical-align: top;
    resize: none;
  }
  tbody > tr:hover {
    background-color: #c8d2d2;
  }
  .total-sum-row {
    font-weight: bold;
  }
  input[type="date"] {
    padding: 0;
  }

  .table-head-th {
    /*min-width: 80px;*/
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 1;
    background: white;
  }
  .table-view {
    overflow-y: scroll;
    position: relative;
    max-height: 800px;
  }

  .contractual-payments-date-picker {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 1.8125rem;
    color: #607d8b;
    padding: 0.5rem 0.75rem;
  }
  .contractual-payments-table-date-picker {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #607d8b;
    padding-left: 10px;
  }
  .edit-contractual-payments-date-picker {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #607d8b;
    padding: 0.5rem 0.75rem;
  }
  .vdp-datepicker__calendar {
    min-width: 200px;
    max-width: fit-content;
  }
  label.vue-switcher {
    margin-bottom: 0;
  }

</style>
<style>
  table .edit-contractual-payments-date-picker {
    width: 80px;
  }
</style>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import modal from 'vue-strap/src/Modal';
import VueNotifications from 'vue-notifications';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import Switches from 'vue-switches';

export default {
  name: 'IncomingPayments',
  components: {
    modal,
    Datepicker,
    Switches,
  },
  data: function () {
    return {
      invoicePaymentTableHeight: 'auto',
      showIncoming: true,
      newIncomingPaymentForecastedPaymentDate: '',
      newIncomingPaymentContractualInvoiceDate: '',
      newIncomingPaymentForecastedInvoiceDate: '',
      newIncomingPaymentProject: this.projectId,
      newIncomingPaymentAmount: '',
      newIncomingPaymentPrepayment: '',
      newIncomingPaymentDescription: '',
      newIncomingPaymentType: 'planned',
      newIncomingPaymentIncoming: true,
      isEditingPayment: false,
      isCreatingContract: false,
      selected_template: '',
      selectedIncomingPayment: {},
      incomingPaymentFilter: {
        filterDateFrom: '',
        filterDateTo: '',
        filterType: ''
      },
      incomingPaymentsTableSum: '',
      prepaymentTableSum: '',
      toBePaidTableSum: '',
    };
  },
  props: {
    projectId: '',
  },
  watch: {
    isEditingPayment: function (val) {
      if (val) {
        $('#incPaymentsRoot').parent().css('z-index', 3000);
      } else {
        setTimeout(() => {
          $('#incPaymentsRoot').parent().css('z-index', 0);
        }, 300);
      }
    },
    incomingPaymentNotification: {
      handler: function (val) {
        if (this.incomingPaymentNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Incoming payment status', message: this.incomingPaymentNotification.message });
          this.newIncomingPaymentForecastedPaymentDate = '';
          this.newIncomingPaymentContractualInvoiceDate = '';
          this.newIncomingPaymentForecastedInvoiceDate = '';
          this.newIncomingPaymentAmount = '';
          this.newIncomingPaymentPrepayment = '';
          this.newIncomingPaymentDescription = '';
          this.newIncomingPaymentType = 'planned';
          this.newIncomingPaymentIncoming = true;
          if (this.isEditingPayment) {
            this.isEditingPayment = false;
          }
        }
        if (this.incomingPaymentNotification.status == 'error') {
          for (const i in this.incomingPaymentNotification.message) {
            this.showErrorMsg({
              title: 'Incoming payment status',
              message: this.incomingPaymentNotification.message[i]
            });
          }
        }
      },
      deep: true
    },
    incomingPayments: {
      handler: function (val) {
        this.recalculateTableSum();
      },
      deep: true
    },
    incomingPaymentFilter: {
      handler: function (val) {
        this.recalculateTableSum();
      },
      deep: true
    },
    selectedIncomingPayment: {
      handler: function () {
        let toBePaid = parseFloat(this.selectedIncomingPayment.amount) + parseFloat(this.selectedIncomingPayment.prepayment);
        if (!toBePaid) {
          toBePaid = 0;
        }
        this.selectedIncomingPayment.toBePaid = toBePaid.toFixed(2);
        console.log(this.selectedIncomingPayment.amount, this.selectedIncomingPayment.prepayment, toBePaid);
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters('IncomingPayments', [
      'incomingPayments',
      'incomingPaymentNotification'
    ]),
    ...mapGetters('JiraProjects', [
      'projects',
    ]),
    ...mapGetters('Templates', [
      'templates_dropdown'
    ]),
    newIncomingPaymentToBePaid: function () {
      const toBePayd = parseFloat(this.newIncomingPaymentAmount) + parseFloat(this.newIncomingPaymentPrepayment);
      return toBePayd ? toBePayd.toFixed(2) : 0;
    },
  },
  methods: {
    ...mapActions('IncomingPayments', [
      'LOAD_INCOMING_PAYMENTS',
      'CREATE_INCOMING_PAYMENT',
      'DELETE_INCOMING_PAYMENT',
      'EDIT_INCOMING_PAYMENT',
    ]),
    ...mapActions('Templates', [
      'TEMPLATES_DROPDOWN'
    ]),
    saveNewIncomingPayment() {
      this.CREATE_INCOMING_PAYMENT({
        expected_on: moment(this.newIncomingPaymentForecastedPaymentDate).format('YYYY-MM-DD'),
        contractual_invoice_date: moment(this.newIncomingPaymentContractualInvoiceDate).format('YYYY-MM-DD'),
        forecasted_invoice_date: moment(this.newIncomingPaymentForecastedInvoiceDate).format('YYYY-MM-DD'),
        project_id: this.newIncomingPaymentProject,
        amount: this.newIncomingPaymentAmount * 100,
        prepayment: this.newIncomingPaymentPrepayment * 100,
        description: this.newIncomingPaymentDescription,
        incoming: this.newIncomingPaymentIncoming,
        type: this.newIncomingPaymentType
      });
    },
    deleteIncomingPayment(incomingPaymentId) {
      this.DELETE_INCOMING_PAYMENT(incomingPaymentId);
    },
    editIncomingPayment(incomingPayment) {
      this.isEditingPayment = true;
      this.selectedIncomingPayment = { ...incomingPayment };
    },
    updateIncomingPayment() {
      this.EDIT_INCOMING_PAYMENT(
        {
          id: this.selectedIncomingPayment.id,
          expected_on: moment(this.selectedIncomingPayment.expected_on).format('YYYY-MM-DD'),
          contractual_invoice_date: moment(this.selectedIncomingPayment.contractual_invoice_date).format('YYYY-MM-DD'),
          forecasted_invoice_date: moment(this.selectedIncomingPayment.forecasted_invoice_date).format('YYYY-MM-DD'),
          project_id: this.selectedIncomingPayment.project_id,
          amount: Math.floor(this.selectedIncomingPayment.amount * 100),
          prepayment: Math.floor(this.selectedIncomingPayment.prepayment * 100),
          description: this.selectedIncomingPayment.description,
          type: this.selectedIncomingPayment.type,
        }
      );
    },
    updateIncomingPaymentForecasetedInvoiceDate(date, incomingPayment) {
      let expectedOn = moment(incomingPayment.expected_on);

      if (this.projects[incomingPayment.project_id].payment_due_days) {
        expectedOn = moment(date).add(this.projects[incomingPayment.project_id].payment_due_days, 'days');
      }

      this.EDIT_INCOMING_PAYMENT(
        {
          id: incomingPayment.id,
          expected_on: expectedOn.format('YYYY-MM-DD'),
          contractual_invoice_date: moment(incomingPayment.contractual_invoice_date).format('YYYY-MM-DD'),
          forecasted_invoice_date: moment(date).format('YYYY-MM-DD'),
          project_id: incomingPayment.project_id,
          amount: Math.floor(incomingPayment.amount * 100),
          prepayment: Math.floor(incomingPayment.prepayment * 100),
          description: incomingPayment.description,
          type: incomingPayment.type,
        }
      );
    },
    incomingPaymentPicketOpen() {
      const tableHeight = this.$refs.invoicePaymentTable.clientHeight + 282;
      this.invoicePaymentTableHeight = `${tableHeight}px`;
      console.log('open', this.$refs.invoicePaymentTable.clientHeight);
    },
    incomingPaymentPickerClose() {
      console.log('close');
      this.invoicePaymentTableHeight = 'inherit';
    },
    showIncomingPayment(incomingPayment) {
      if (incomingPayment.incoming && !this.showIncoming
                  || !incomingPayment.incoming && this.showIncoming
      ) {
        return false;
      }
      if (this.incomingPaymentFilter.filterDateFrom != ''
              || this.incomingPaymentFilter.filterDateTo
      ) {
        return (
          !this.projectId && incomingPayment.forecasted_invoice_date >= moment(this.incomingPaymentFilter.filterDateFrom).format('YYYY-MM-DD')
                      && incomingPayment.forecasted_invoice_date <= moment(this.incomingPaymentFilter.filterDateTo).format('YYYY-MM-DD')
                      && (!this.incomingPaymentFilter.filterType || this.incomingPaymentFilter.filterType == incomingPayment.type)
        )
                  || (incomingPayment.project_id == this.projectId
                          && incomingPayment.forecasted_invoice_date >= moment(this.incomingPaymentFilter.filterDateFrom).format('YYYY-MM-DD')
                          && incomingPayment.forecasted_invoice_date <= moment(this.incomingPaymentFilter.filterDateTo).format('YYYY-MM-DD')
                          && (!this.incomingPaymentFilter.filterType || this.incomingPaymentFilter.filterType == incomingPayment.type)
                  );
      }
      return !this.projectId
                      && (!this.incomingPaymentFilter.filterType || incomingPayment.type == this.incomingPaymentFilter.filterType)
                      || this.projectId == incomingPayment.project_id
                      && (!this.incomingPaymentFilter.filterType || incomingPayment.type == this.incomingPaymentFilter.filterType);
    },
    recalculateTableSum() {
      let sum = 0;
      let sum2 = 0;
      let sum3 = 0;
      for (const i in this.incomingPayments) {
        if (this.showIncomingPayment(this.incomingPayments[i])) {
          sum += this.incomingPayments[i].amount;
          sum2 += this.incomingPayments[i].prepayment;
          sum3 += this.incomingPayments[i].toBePaid;
        }
      }
      this.incomingPaymentsTableSum = sum;
      this.prepaymentTableSum = sum2;
      this.toBePaidTableSum = sum3;
    },
    openContractModal(incomingPayment) {
      this.selectedIncomingPayment = { ...incomingPayment };
    },
    createNewContract() {
      if (this.selected_template !== '') {
        this.$router.push({ name: 'NewContract',
          params: {
            id: this.selected_template,
            overrideParams: {
              invoice: this.selectedIncomingPayment,
              project: this.projects[this.selectedIncomingPayment.project_id]
            },
          } });
      } else {
        this.showErrorMsg({ title: 'Contract creation status', message: 'Please select contract template.' });
      }
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
    this.TEMPLATES_DROPDOWN();
    this.LOAD_INCOMING_PAYMENTS();
  }
};
</script>
